import React from 'react';
import { AnimatedSection } from './AnimatedSection';
export function TrustBar() {
  return;
}